<template>
  <div class="g-missing-et-alarm">
    <p>
      {{ $t('messages.alarms.serviceMissingETAlarm.description') }}
    </p>

    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <!-- <h3 class="g-text g-text--center">
      {{ $t('messages.alarms.suggestion') }}
    </h3> -->

    <div class="g-alarm-handler__row g-text">
      <ol>
        <li>{{ $t('messages.alarms.serviceMissingETAlarm.label1') }}</li>
        <li>{{ $t('messages.alarms.serviceMissingETAlarm.label2') }}</li>
        <li>{{ $t('messages.alarms.serviceMissingETAlarm.label3') }}</li>
        <li>{{ $t('messages.alarms.serviceMissingETAlarm.label4') }}</li>
      </ol>
    </div>
  </div>
</template>

<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'

export default {
  name: 'ServiceMissingETAlarm',
  mixins: [ServiceAlarm]
}
</script>
